import React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";

import { Skeleton } from "components";
import { hasPermissions, userPermissionSet } from "helpers";
import { useLoader } from "hooks";

import styles from "./layout.module.scss";

type UserNameLinkProps = {
	className?: string;
	style?: React.CSSProperties;
	fullName: string | undefined;
	url: string;
	isLoading?: boolean;
};

export const UserNameLink = ({
	className,
	fullName,
	url,
	style,
	isLoading = false,
}: UserNameLinkProps) => {
	const Loader = useLoader(isLoading);

	return (
		<Loader
			skeleton={
				<Skeleton
					variant="text"
					height="20px"
					width="100px"
					maxWidth="150px"
				/>
			}
			component={
				<div
					className={clsx(styles.userNameLink, className)}
					style={{ ...style }}
				>
					{url && hasPermissions(userPermissionSet) ? (
						<Link to={url} target="_blank">
							{fullName}
						</Link>
					) : (
						<span className={styles.userName}>{fullName}</span>
					)}
				</div>
			}
		/>
	);
};
